var map = {
	"./api.png": 6480,
	"./bem.png": 974,
	"./bootstrap.png": 5489,
	"./cpanel.png": 6738,
	"./css.png": 8627,
	"./electron.png": 8130,
	"./express.png": 2898,
	"./figma.png": 7075,
	"./github.png": 3744,
	"./html.png": 8234,
	"./javascript.png": 7986,
	"./jquery.png": 1852,
	"./laragon.png": 8639,
	"./laravel.png": 4253,
	"./mevn.png": 7232,
	"./mobile_first.png": 3489,
	"./mongodb.png": 3940,
	"./mysql.png": 3025,
	"./node.png": 1745,
	"./payload.png": 5495,
	"./photopea.png": 8482,
	"./php.png": 4114,
	"./postman.png": 6515,
	"./pwa.png": 945,
	"./sass.png": 7073,
	"./seo.png": 3994,
	"./sql.png": 1298,
	"./strapi.png": 2244,
	"./tailwind.png": 2822,
	"./vite.png": 3897,
	"./vue.png": 1001,
	"./wampserver.png": 9383,
	"./wordpress.png": 2944,
	"./xampp.png": 6396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9140;